import Vue from 'vue'
import moment from 'moment'

Vue.filter('toDate', function(value, arg) {
    const time = moment(value)
    if (time.isValid())
    {
        if (arg)
        {
            return time.format(arg)
        } else {
            return time.format('YYYY-MM-DD')
        }
    }
})

Vue.filter('toDateTime', function(value, arg) {
    const time = moment(value)
    if (time.isValid())
    {
        if (arg)
        {
            return time.format(arg)
        } else {
            return time.format('YYYY-MM-DD HH:mm:ss')
        }
    }
})

Vue.filter('shortDate', function(value, arg) {
    const time = moment(value)
    if (time.isValid())
    {
        if (arg)
        {
            return time.format(arg)
        } else {
            return time.format('YYYY-MM-DD HH:mm')
        }
    }
})

Vue.filter('toPrice', function(value) {
  const formatter = new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: 'HUF'
  })
  return formatter.format(value)
})



// WEBPACK FOOTER //
// ./src/filters/index.js